import script from "./GodApeQuestTeamChoice.vue?vue&type=script&setup=true&lang=js"
export * from "./GodApeQuestTeamChoice.vue?vue&type=script&setup=true&lang=js"

import "./GodApeQuestTeamChoice.vue?vue&type=style&index=0&id=2a782a67&lang=scss"

const __exports__ = script;

export default __exports__